import React, { useEffect, Suspense, lazy, createElement } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
const RealResultsSection = lazy(() => import('./components/RealResultsSection').then(m => ({
  default: m.RealResultsSection
})));
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencyOfferSection = lazy(() => import('./components/UrgencyOfferSection').then(m => ({
  default: m.UrgencyOfferSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const MentorSection = lazy(() => import('./components/MentorSection').then(m => ({
  default: m.MentorSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
const SuppliersGiftSection = lazy(() => import('./components/SuppliersGiftSection').then(m => ({
  default: m.SuppliersGiftSection
})));
export function App() {
  useEffect(() => {
    ReactPixel.init('1308924823976675');
    ReactPixel.pageView();
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'ukxbt6i9cor3c23xr4j0lek38bvd3m';
    document.head.appendChild(meta);
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdn.magicpatterns.com'];
    const links: HTMLLinkElement[] = [];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.head.removeChild(meta);
      links.forEach(link => document.head.removeChild(link));
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#2F0240]" data-id="element-0" data-mp="3bmtjbb5e3y3x">
      <UrgencyBar data-id="element-1" data-mp="3bo4j6zvpslpr" />
      <HeroSection data-id="element-2" data-mp="3bkgtycxaylgu" />
      <TransformationSection data-id="element-3" data-mp="3qbpnuy88mszs" />

      <Suspense fallback={<div className="min-h-[200px]" data-id="element-5" data-mp="3qcinzgcoyk8y" />} data-id="element-4" data-mp="3qbze8mx73260">
        <SuppliersGiftSection data-id="element-6" data-mp="3lkr2vlcb16q7" />
        <RealResultsSection data-id="element-7" data-mp="3ljphamxnx1u8" />
        <IncludesSection data-id="element-8" data-mp="3liedin47vu34" />
        <MentorSection data-id="element-9" data-mp="2xun2rnybrp3y" />
        <TestimonialsSection data-id="element-10" data-mp="2xu3iw1p46qna" />
        <BonusesSection data-id="element-11" data-mp="2xtbw9gdhw395" />
        <UrgencyOfferSection data-id="element-12" data-mp="2xsk4kgn0qpo5" />
        <PricingSection data-id="element-13" data-mp="2swbu3gjrnknb" />
        <FAQSection data-id="element-14" data-mp="2sv0r3iy5agx9" />
        <FooterSection data-id="element-15" data-mp="2svjy44m9bkwi" />
        <SocialProofPopup data-id="element-16" data-mp="18driltpr7bcr" />
      </Suspense>
    </div>;
}